// removed by extract-text-webpack-plugin
module.exports = {"list":"c-VoucherList__list","item":"c-VoucherList__item","voucher":"c-VoucherList__voucher","priceOff":"c-VoucherList__priceOff","code":"c-VoucherList__code","remove":"c-VoucherList__remove"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/VoucherList/VoucherList.scss
// module id = 841
// module chunks = 0